// A place was just picked by typing it - in the map's place search, or on the landing
// page before the map opened - so the dropped pin's tip (DropPinMapControl) can say the
// map can be pressed instead. Kept until the tip takes it, as the landing page's pick
// happens before the map, and so the tip, is there to hear the event.
export const PLACE_SEARCHED_EVENT = 'tms:place-searched';

let pending = false;

export const notePlaceSearched = () => {
    pending = true;
    window.dispatchEvent(new Event(PLACE_SEARCHED_EVENT));
};

export const placeSearchedPending = () => pending;

// Taken once the tip is up
export const takePlaceSearched = () => {
    pending = false;
};
